document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.b2b-why > div');

    if (cards === null) {
        return;
    }

    cards.forEach(card => {
        const helpButton = card.querySelector('.b2b-why__help');
        const closeButton = card.querySelector('.b2b-why__close');
        const title = card.querySelector('.b2b-why__avers')?.textContent?.trim() || 'карточка';
        const runOnKeyboard = (handler) => (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handler();
            }
        };

        // Добавление класса b2b-why_reverse при клике на b2b-why__help
        if (helpButton) {
            const openCard = () => {
                card.classList.add('b2b-why_reverse');
            };

            helpButton.setAttribute('tabindex', '0');
            helpButton.setAttribute('role', 'button');
            helpButton.setAttribute('aria-label', `Подробнее: ${title}`);
            helpButton.addEventListener('click', openCard);
            helpButton.addEventListener('keydown', runOnKeyboard(openCard));
        }

        // Удаление класса b2b-why_reverse при клике на b2b-why__close
        if (closeButton) {
            const closeCard = () => {
                card.classList.remove('b2b-why_reverse');
            };

            closeButton.setAttribute('tabindex', '0');
            closeButton.setAttribute('role', 'button');
            closeButton.setAttribute('aria-label', `Скрыть подробности: ${title}`);
            closeButton.addEventListener('click', closeCard);
            closeButton.addEventListener('keydown', runOnKeyboard(closeCard));
        }
    });
});
